import { CuttingState } from "./CuttingState.d";
import { ShipmentState } from "./ShipmentState.d";
import { ShipmentType } from "./ShipmentType.d";
import { UserType } from "./UserType.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity AccountingUsers


export interface AccountingUser {
    id: ID;

    
    email: string;

    
    name: string;

    
    description?: string;

    
    userId: ID;

    
    scopeGroupId: ID;

    }




export interface CreateAccountingUser {
    
    email: string;

    
    name: string;

    
    description?: string;

    
    
    }


export interface UpdateAccountingUser {
    
    
    name: string;

    
    description?: string;

    
    
    }

export interface PresentationAccountingUserRequest {
    list: ListRequest,
    filter: {
        email: string,
        emailOr: boolean,
        name: string,
        nameOr: boolean,
        userIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryAccountingUser {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: AccountingUser): PrimaryAccountingUser | undefined {
        return entity ? new PrimaryAccountingUser(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryAccountingUser {
        return new PrimaryAccountingUser(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryAccountingUser {
        let vals = path?.split('/');
        return new PrimaryAccountingUser(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryAccountingUser[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: AccountingUser): string {
    let fields = entity ? [
    entity.email,
            entity.name,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityAccountingUser {
    id: PrimaryAccountingUser;
    data: UpdateAccountingUser;


    constructor(id: PrimaryAccountingUser, data: UpdateAccountingUser) {
        this.id = id;
        this.data = data;
    }
}
